import { render } from "./Comic.vue?vue&type=template&id=7893f864"
import script from "./Comic.vue?vue&type=script&lang=js"
export * from "./Comic.vue?vue&type=script&lang=js"

import "./Comic.vue?vue&type=style&index=0&id=7893f864&lang=css"

import exportComponent from "C:\\Users\\Trix\\Documents\\manga-corporation-V2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__